import { _p, _e } from '../core.crypto';

interface cognitoConfig {
    userPoolId: string,
    userPoolClientId: string,
    region: string,
};

const _cProd = {
    userPoolClientId: 'U2FsdGVkX190Sz+Sy8sF0YWwo1O1i7NWFb2NGdpXQOEE60E6cPT83Ub2KBUjCQAr',
    userPoolId: 'U2FsdGVkX18Z45hAU2+vo80fbMO6l5ahDONJoZucRr5qj4+flpXYaNQ9cIAtDk/C',
    region: 'U2FsdGVkX1+lc2C17RuPt29RB5/4NnEuWUBbq5vaegk='
};

const _cStaging = {
    userPoolClientId: 'U2FsdGVkX1+hwVMD6nD1+gXxamSCKo4n5CJAsq5ESON2Xcw4dY0kVfBfTni2/zpz',
    userPoolId: 'U2FsdGVkX19ScH7d+QJDouMkeLIdlmh95tG04WifMR4EDM3gdZ49teAVh0xn2QDD',
    region: 'U2FsdGVkX18Ojocb9scpvPfwtq3T+00hcMhIv/YZrSs='
};

// Configuración de development
const _cDev = {
    userPoolClientId: 'U2FsdGVkX1/BNPLtxbwPX47AYNb0qZP79t7S3Q++GI4ORjx1f6E1KBCZ8zNcpo3f',
    userPoolId: 'U2FsdGVkX1/toCnst5/HfF87tFTkRM0Hu9l5KIRl4pyCiANoBXQI7ylPfsc/5rsB',
    region: 'U2FsdGVkX1+BksbjyX8+KvOttjgYxbCv4veH8eqEQ0A='
};

const _g = (): cognitoConfig => {
    const idx = parseInt(_e(), 10);
    const cfg = idx === 4 ? _cDev : (idx === 1 ? _cStaging : _cProd);
    return _p<cognitoConfig>(cfg);
};

export const COGNITO_CONFIG = _g();
